/* istanbul ignore file */
export const isDarkTheme = () => window.matchMedia?.('(prefers-color-scheme: dark)').matches
